<template>
  <q-card class="q-pa-md" style="width:160px; max-height:380px;">
    <div class="text-subtitle1 q-mb-sm" style="line-height:1rem;">
      Заменить {{this.alt ? 'в подъездах' : 'этаж'}}
    </div>

    <q-linear-progress v-if="this.isFetching" indeterminate />
    <q-scroll-area
      v-else-if="!!this.list?.length"
      style="height:220px; margin-top: 10px;"
    >
      <q-list>
        <q-item
          clickable
          v-ripple
          dense
          style="padding:0;"
          @click="toggleAll()"
        >
          <q-item-section avatar style="padding-right:5px;" @click.stop>
            <CustomCheckbox
              size="xs"
              :value="isAllSelected"
              @change="onToggleAllChange"
            />
          </q-item-section>
          <q-item-section> Все </q-item-section>
        </q-item>

        <q-separator spaced size="xs" style="margin: 5px 0;" />

        <q-item
          v-for="floor in this.list"
          :key="this.alt ? floor.entrance : floor.floor_map_id"
          :clickable="!floor.disabled"
          v-ripple
          dense
          style="padding:0;"
          @click="toggleFloor(this.alt ? floor.entrance : floor.floor_map_id)"
        >
          <q-item-section avatar style="padding-right:5px;" @click.stop>
            <CustomCheckbox
              size="xs"
              :disable="!!floor.disabled"
              :value="!!selectedFloors[this.alt ? floor.entrance : floor.floor_map_id]"
              @change="(e) => onCheckChange(this.alt ? floor.entrance : floor.floor_map_id, e)"
            />
          </q-item-section>
          <q-item-section>
            <span :style="{color: floor.disabled ? '#ccc' : ''}"
              >{{ floor[this.alt ? 'entrance' : 'level_num'] }}
              {{this.alt ? 'Подъезд' : 'этаж'}}</span
            >
          </q-item-section>
        </q-item>
      </q-list>
    </q-scroll-area>
    <NotFoundText v-else />

    <q-btn
      label="Заменить"
      color="primary"
      padding="xs"
      :loading="this.loading"
      :disable="this.btnDisabled"
      style="text-transform:capitalize; font-weight:400;"
      class="full-width q-mt-md"
      @click="handleSubmit"
    />
  </q-card>
</template>

<script>
import NotFoundText from '@/components/common/NotFoundText.vue';
import CustomCheckbox from "@/components/form/CustomCheckbox";

export default {
  name: "ChangeMaterialsList",
  props: ['isFetching', 'list', 'onSubmit', 'alt', 'floorMapId'],
  components: {NotFoundText, CustomCheckbox},
  data() {
    return {
      selectedFloors: this.alt ? {} : { [this.floorMapId]: true },
      loading: false
    }
  },
  methods: {
    async handleSubmit() {
      if(!this.onSubmit) return
      this.loading = true
      await this.onSubmit(this.selectedFloors)
      this.loading = false
    },
    onCheckChange(floor_map_id, value) {
      this.selectedFloors[floor_map_id] = value
    },
    toggleFloor(floor_map_id) {
      const next = !this.selectedFloors[floor_map_id]
      this.selectedFloors[floor_map_id] = next
    },
    setAll(value) {
      this.list.forEach(f => {
        if(!f.disabled)
          this.selectedFloors[this.alt ? f.entrance : f.floor_map_id] = value
      })
    },
    onToggleAllChange(val) {
      this.setAll(!!val)
    },
    toggleAll() {
      this.setAll(!this.isAllSelected)
    }
  },
  computed: {
    btnDisabled() {
      if(!this.list?.length) return true
      return !Object.keys(this.selectedFloors)
        .filter(floorMapId => !!this.selectedFloors[floorMapId])?.length
    },
    isAllSelected() {
      if (!this.list?.length) return false
      return this.list.every(f => f.disabled ? true : !!this.selectedFloors[this.alt ? f.entrance : f.floor_map_id])
    }
  },
}
</script>
